import React from 'react';

import PropTypes from 'prop-types';
import { FaPhone, FaEnvelope, FaUser } from 'react-icons/fa';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useTranslation } from 'react-i18next';

import WithBackground from '../Common/WithBackground';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './style.css';

const TeamHr = ({ bg, overlay }) => {
  const { t } = useTranslation();

  const hrTeamMembers = [
    {
      id: 1,
      name: t('teamHr.members.ewaDowhan.name'),
      position: t('teamHr.members.ewaDowhan.position'),
      phone: t('teamHr.members.ewaDowhan.phone'),
      email: t('teamHr.members.ewaDowhan.email'),
    },
    {
      id: 2,
      name: t('teamHr.members.martaSzlachtycz.name'),
      position: t('teamHr.members.martaSzlachtycz.position'),
      phone: t('teamHr.members.martaSzlachtycz.phone'),
      email: t('teamHr.members.martaSzlachtycz.email'),
    },
    {
      id: 3,
      name: t('teamHr.members.annaDudzinska.name'),
      position: t('teamHr.members.annaDudzinska.position'),
      phone: t('teamHr.members.annaDudzinska.phone'),
      email: t('teamHr.members.annaDudzinska.email'),
    },
    {
      id: 4,
      name: t('teamHr.members.orianaProchnicka.name'),
      position: t('teamHr.members.orianaProchnicka.position'),
      phone: t('teamHr.members.orianaProchnicka.phone'),
      email: t('teamHr.members.orianaProchnicka.email'),
    },
    {
      id: 5,
      name: t('teamHr.members.dominikaWyruszynska.name'),
      position: t('teamHr.members.dominikaWyruszynska.position'),
      phone: t('teamHr.members.dominikaWyruszynska.phone'),
      email: t('teamHr.members.dominikaWyruszynska.email'),
    },
  ];

  const teamHrContent = (
    <section className='team-hr'>
      <div className='team-hr__container'>
        <div className='team-hr__header'>
          <h2 className='team-hr__title'>{t('teamHr.title')}</h2>
          <p className='team-hr__intro'>{t('teamHr.intro')}</p>
        </div>

        <div className='team-hr__swiper-container'>
          <Swiper
            modules={[Navigation, Pagination]}
            navigation={{ nextEl: '.team-hr__next', prevEl: '.team-hr__prev' }}
            pagination={{ el: '.team-hr__pagination', clickable: true }}
            spaceBetween={24}
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 16 },
              769: { slidesPerView: 2, spaceBetween: 20 },
              1025: { slidesPerView: 3, spaceBetween: 24 },
            }}
            className='team-hr-swiper'
          >
            {hrTeamMembers.map((member) => (
              <SwiperSlide key={member.id}>
                <div className='team-hr-card'>
                  <div className='team-hr-card__header'>
                    <div className='team-hr-card__avatar'>
                      <FaUser />
                    </div>
                    <div className='team-hr-card__info'>
                      <h3 className='team-hr-card__name'>{member.name}</h3>
                      <p className='team-hr-card__position'>
                        {member.position}
                      </p>
                    </div>
                  </div>

                  <div className='team-hr-card__contact'>
                    <div className='team-hr-card__contact-item'>
                      <FaPhone />
                      <a
                        href={`tel:${member.phone}`}
                        className='team-hr-card__contact-link'
                      >
                        {member.phone}
                      </a>
                    </div>
                    <div className='team-hr-card__contact-item'>
                      <FaEnvelope />
                      <a
                        href={`mailto:${member.email}`}
                        className='team-hr-card__contact-link'
                      >
                        {member.email}
                      </a>
                    </div>
                  </div>

                  <div className='team-hr-card__action'>
                    <a
                      href={`tel:${member.phone}`}
                      className='team-hr-card__contact-btn'
                    >
                      <FaPhone />
                      {t('teamHr.callButton')}
                    </a>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className='team-hr__navigation'>
            <button className='team-hr__prev' aria-label='Previous member'>
              <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
                <path
                  d='M15 18L9 12L15 6'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </button>

            <button className='team-hr__next' aria-label='Next member'>
              <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
                <path
                  d='M9 18L15 12L9 6'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </button>
          </div>

          <div className='team-hr__pagination'></div>
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {teamHrContent}
    </WithBackground>
  ) : (
    teamHrContent
  );
};

TeamHr.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

TeamHr.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default TeamHr;
